import React, { useEffect, useState } from "react";
import Card from "./Card";

type Props = {
  locationName: string;
  title?: string;
  subtitle?: string;
  agency: Agency;
  featureData: {
    title: string;
    subtitle: string;
    desc: string;
  }[];
};

const AgencyCarFeatures = (props: Props) => {
  const [isUserAgentBot, setIsUserAgentBot] = useState(true);
  useEffect(() => {
    if (!/bot/i.test(navigator.userAgent)) setIsUserAgentBot(false);
  }, []);
  return (
    <section id="features-cards" className="px-[13px]">
      <div className="max-w-7xl mx-auto mt-[22px] mb-[18px] lg:my-[60px]">
        <div className="space-y-[6px] lg:space-y-[10px] mb-[18px]">
          <h2 className="font-extrabold text-lg lg:text-[30px] text-my-dark-blue leading-[2.2rem]">
            {props.title
              ? props.title
              : `Things to know about ${props.agency.name} in ${props.locationName}`}
          </h2>
          <p className="space-y-6 text-sm font-normal text-my-light-blue lg:font-light lg:text-base">
            {props.subtitle
              ? props.subtitle
              : `If you are looking for a great car rental experience from ${props.locationName}, there is no better option than ${props.agency.name}. With a focus on customer satisfaction and smooth renting experience, ${props.agency.name} is the best rental car company at ${props.locationName}. So, if you are wondering which car to book, the below details will help you choose one.`}
          </p>
        </div>
        {isUserAgentBot ? (
          <table className="w-full">
            {props.featureData.map((data, index) => {
              return (
                <tr key={index}>
                  <th>{data.subtitle}</th>
                  <td>{data.title}</td>
                </tr>
              );
            })}
          </table>
        ) : (
          <div className="md:grid grid-cols-2 lg:grid-cols-4 gap-6 rounded-[16px] md:rounded-none overflow-clip mt-[18px] lg:mt-10">
            {props.featureData.map((data, index) => {
              return (
                <Card
                  key={index}
                  subtitle={data.subtitle}
                  title={data.title}
                  desc={data.desc}
                />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default AgencyCarFeatures;
